export const assetTransactions = [
  {
    id: "pui_id_1",
    lmaxId: "332048hdf023408hf230j2d",
    datetime: "2024-11-01T02:32:00Z",
    sender: {
      account: "Account 3",
      address: "0x66a324932049234092344sdfkjsdf4083as",
    },
    recipient: {
      account: "Acme Limited ETH",
      address: "0x66a324932049234092344sdfkjsdf4083as",
    },
    type: "DEBIT",
    amount: {
      amountString: "12.34 ETH",
      valuation: {
        amount: 27718.42,
      },
    },
    withdrawalRequest: {
      id: "123",
      reference: "my withdrawal",
    },
    blockchain: "SOLANA",
    status: "Complete",
  },
  {
    id: "pui_id_2",
    lmaxId: "532asdfhdf023408hf230j2d",
    datetime: "2025-01-01T02:32:00Z",
    sender: {
      account: "Account 3",
      address: "0x66a324932049234092344sdfkjsdf4083as",
    },
    recipient: {
      account: "Unknown Address",
      address: "0x66a324932049234092344sdfkjsdf4083as",
    },
    type: "DEBIT",
    amount: {
      amountString: "2.34 ETH",
      valuation: {
        amount: 5256.17,
      },
    },
    status: "Pending",
  },
  {
    id: "pui_id_3",
    lmaxId: "732asdfhdf023408hf230j2d",
    datetime: "2025-07-11T02:32:00Z",
    sender: {
      account: "Acme Limited SOL",
      address: "0x66a324932049234092344sdfkjsdf4083as",
    },
    recipient: {
      account: "Account 4",
      address: "0x66a324932049234092344sdfkjsdf4083as",
    },
    type: "CREDIT",
    amount: {
      amountString: "0.0034 ETH",
      valuation: {
        amount: 763.72,
      },
    },
    status: "Processing",
  },
  {
    id: "pui_id_4",
    lmaxId: "932asdfhdf023408hf230j2s",
    datetime: "2025-02-12T02:32:00Z",
    sender: {
      account: "Account 3",
      address: "0x66a324932049234092344sdfkjsdf4083as",
    },
    recipient: {
      account: "Acme Limited ETH",
      address: "0x66a324932049234092344sdfkjsdf4083as",
    },
    type: "DEBIT",
    amount: {
      amountString: "4.42000 ETH",
      valuation: {
        amount: 9928.31,
      },
    },
    status: "Complete",
  },
  {
    id: "pui_id_5",
    lmaxId: "232asdfhdf023408hf230j2x",
    datetime: "2025-05-01T02:32:00Z",
    sender: {
      account: "Account 3",
      address: "0x66a324932049234092344sdfkjsdf4083as",
    },
    recipient: {
      account: "Acme Limited ETH",
      address: "0x66a324932049234092344sdfkjsdf4083as",
    },
    type: "DEBIT",
    amount: {
      amountString: "12.34000 ETH",
      valuation: {
        amount: 27718.42,
      },
    },
    status: "Cancelled",
  },
];
